import React from "react";

export const FileIcon = () => {
  return (
    <div>
      <svg
        width="22"
        height="28"
        viewBox="0 0 22 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5654 15.8281L11.5742 15.7871C11.7441 15.0869 11.958 14.2139 11.791 13.4229C11.6797 12.7988 11.2197 12.5557 10.8271 12.5381C10.3643 12.5176 9.95117 12.7812 9.84863 13.165C9.65527 13.8682 9.82812 14.8291 10.1445 16.0537C9.74609 17.0029 9.11035 18.3828 8.64453 19.2031C7.77734 19.6514 6.61426 20.3428 6.44141 21.2158C6.40625 21.377 6.44727 21.582 6.54395 21.7666C6.65234 21.9717 6.8252 22.1299 7.02734 22.2061C7.11523 22.2383 7.2207 22.2646 7.34375 22.2646C7.85938 22.2646 8.69434 21.8486 9.80762 19.9385C9.97754 19.8828 10.1533 19.8242 10.3232 19.7656C11.1201 19.4961 11.9463 19.2148 12.6934 19.0889C13.5195 19.5312 14.46 19.8154 15.0986 19.8154C15.7314 19.8154 15.9805 19.4404 16.0742 19.2148C16.2383 18.8193 16.1592 18.3213 15.8926 18.0547C15.5059 17.6738 14.5654 17.5742 13.1006 17.7559C12.3799 17.3164 11.9082 16.7188 11.5654 15.8281ZM8.35156 20.2783C7.94434 20.8701 7.63672 21.166 7.46973 21.2949C7.66602 20.9346 8.0498 20.5537 8.35156 20.2783ZM10.918 13.3789C11.0703 13.6396 11.0498 14.4277 10.9326 14.8262C10.7891 14.2432 10.7686 13.417 10.8535 13.3203C10.877 13.3232 10.8975 13.3408 10.918 13.3789ZM10.8711 16.9092C11.1846 17.4512 11.5801 17.917 12.0166 18.2627C11.3838 18.4062 10.8066 18.6436 10.291 18.8545C10.168 18.9043 10.0479 18.9541 9.93066 19.001C10.3203 18.2949 10.6455 17.4951 10.8711 16.9092ZM15.4297 18.8281C15.4326 18.834 15.4355 18.8428 15.418 18.8545H15.4121L15.4063 18.8633C15.3828 18.8779 15.1426 19.0186 14.1084 18.6113C15.2979 18.5557 15.4268 18.8252 15.4297 18.8281ZM21.0371 7.45508L14.7324 1.15039C14.5566 0.974609 14.3193 0.875 14.0703 0.875H1.625C1.10645 0.875 0.6875 1.29395 0.6875 1.8125V26.1875C0.6875 26.7061 1.10645 27.125 1.625 27.125H20.375C20.8936 27.125 21.3125 26.7061 21.3125 26.1875V8.12012C21.3125 7.87109 21.2129 7.63086 21.0371 7.45508ZM19.1504 8.55078H13.6367V3.03711L19.1504 8.55078ZM19.2031 25.0156H2.79688V2.98438H11.6445V9.3125C11.6445 9.63884 11.7742 9.95182 12.0049 10.1826C12.2357 10.4133 12.5487 10.543 12.875 10.543H19.2031V25.0156Z"
          fill="black"
        />
      </svg>
    </div>
  );
};

export const Blocks = () => {
  return (
    <div>
      <svg
        width="24"
        height="22"
        viewBox="0 0 24 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24 0.5V3.5H0V0.5H24ZM15 6.5V9.5H0V6.5H15ZM24 6.5V9.5H18V6.5H24ZM9 12.5V15.5H0V12.5H9ZM24 12.5V15.5H12V12.5H24ZM18 18.5V21.5H0V18.5H18Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export const ArrowPdf = () => {
  return (
    <div>
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.6049 7.09427L13.2424 21.2052C12.774 21.6091 12.774 22.3868 13.2424 22.795L29.6049 36.906C30.215 37.4302 31.1088 36.9575 31.1088 36.1111V7.88919C31.1088 7.04271 30.215 6.57005 29.6049 7.09427Z"
          fill="white"
        />
        <g filter="url(#filter0_d)">
          <path
            d="M31.1555 11.1598L19.2555 21.4223C18.9148 21.7161 18.9148 22.2817 19.2555 22.5786L31.1555 32.8411C31.5992 33.2223 32.2492 32.8786 32.2492 32.2629V11.7379C32.2492 11.1223 31.5992 10.7786 31.1555 11.1598Z"
            fill="#EE7F0D"
          />
        </g>
        <defs>
          <filter
            id="filter0_d"
            x="13"
            y="7"
            width="21.2492"
            height="30.0009"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="-2" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};
